// extracted by mini-css-extract-plugin
export default {"switcher":"theme-switcher_switcher__FifjW","option":"theme-switcher_option__+EeFn","active":"theme-switcher_active__MBBde"};